<template>
  <div style="padding-left: 1.75rem;">
    <div class="col2_head">
      <span><router-link :to="'/'" class="breadcrumb_home">Acasă /</router-link> {{ $route.name }}<div class="subHeadTitle">{{ $route.name }}</div></span>
      <div class="right" style="margin-top: 1.2rem;">
        <div v-if="PERMISIONS.create" class="right">
          <div @click="addItem" class="Button1">
            <div class="icon">
              <img @load="imgLoaded" src="../assets/media/for_table/circle_ADD_new_etap.svg" alt="">
            </div>
            <span class="Btn_content">
              Adaugă sursă finanțare
            </span>
          </div>
        </div>
      </div>
    </div>
    <template v-if="PERMISIONS.list">
      <table-parent
        :reloadCount="reloadTable"
        :tableHead="tableHead"
        :prepareFn="prepareData"
        :apiModule="tableModule"
        :apiModuleName="'FINANCING_SOURCE'"
        :tableMinimizeHead="true"
        :tableSpread="true"
        @Btn2="editItem"
        @Btn3="deleteItem"
        @totalRecords="x => (totalRecords = x)"
      />
    </template>
    <template v-else>
      <h3 style="display: flex; flex-direction: column; align-items: center;">
        <span style="font-size: 4rem;">
          <i class="fas fa-exclamation-triangle"></i>
        </span>
        Acces interzis
      </h3>
    </template>
  </div>
</template>

<script>
  import PermisionsMixin from '@/mixins/boudgetFinancingPermMixin.js'
  import { FINANCING_SOURCE } from '../api.js'
  import TableParent from '@/components/TableParent'
  import DialogModal from '@/components/DialogModal'

  export default {
    $Title() {
      return `ConectX - ${this.$route.name}`
    },
    mixins: [PermisionsMixin],
    components: {
      TableParent
    },
    data() {
      return {
        reloadTable: 0,
        tableHead: [
          {title:'Denumire sursă finanțare',sort:true,
          queryKey: 'sourceName',
          bottomHead: {
              quikFiltre: true
          }}
        ],
        tableModule: FINANCING_SOURCE.get,
        totalRecords: 0,
      }
    },
    methods: {
      reloadPage() {
        this.reloadTable++
        this.totalRecords = 0
      },
      addItem() {
        this.$modal.show(
          DialogModal,
          {
            target: 'AddFinancing',
            title: 'Adaugă sursă de finanțare',
            inputs: [
              {
                id: 'sourceName',
                label: 'Denumire sursă finanțare',
                errReason: 'Introduceți denumirea sursa de finanțare.',
              }
            ],
            closeBtnText: 'Anulează',
            button: {
              type: 2,
              value: 'Adaugă',
              handler: sendData => {
                const error = msg => {
                  this.$toastr.e(msg || 'Adăugarea sursei de finanțare a eșuat.')
                  this.reloadPage()
                  this.setLoad()
                }

                this.setSafeLoad(12000)
                FINANCING_SOURCE.add(sendData)
                  .then(res => {
                    if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                      this.$toastr.s('Sursa de finanțare a fost adăugată.')
                      this.reloadPage()
                      this.setLoad()
                    } else {
                      error()
                    }
                  })
                  .catch(error)
              },
            },
          },
          {
            name: 'AddFinancing',
            adaptive: true,
            width: '650',
            height: '800',
          }
        )
      },
      deleteItem(item) {
        if(!Number.isInteger(item?.id)) {
          this.$toastr.e('Anunțați administratorul.')
          return
        }
        
        this.$modal.show(
          DialogModal,
          {
            target: 'DeleteFinancing',
            title: 'Ștergere sursă de finanțare',
            content: '<span style="color:#f44336;display: block;margin-top: 2rem;"><i class="fas fa-exclamation-circle" style="font-size: 6rem;"></i> <p style="font-weight: 500;font-size: 2.2rem;">Ești sigur că vrei să ștergi sursa de finanțare selectată?</p></span>',
            closeBtnText: 'Anulează',
            button: {
              type: 3,
              value: 'Șterge',
              handler: () => {
                const err = msg => this.$toastr.e(msg || 'Ștergerea sursei de finanțare a eșuat.')

                this.setSafeLoad()
                FINANCING_SOURCE.delete(item.id).then(res => {
                  if(this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s('Sursa de finanțare a fost ștearsă cu succes.')
                  } else {
                    err()
                  }
                  this.setLoad()
                  this.reloadPage()
                }).catch(msg => {
                  err(msg)
                  this.setLoad()
                  this.reloadPage()
                })
              }
            }
          },
          {
            name: 'DeleteFinancing',
            adaptive: true,
            width: '650',
            height: '400'
          }
        )
      },
      editItem(item) {
        if(!Number.isInteger(item?.id)) {
          this.$toastr.e('Anunțați administratorul.')
          return
        }

        this.$modal.show(
          DialogModal,
          {
            target: 'EditFinancing',
            title: 'Modifică sursă de finanțare',
            inputs: [
              {
                id: 'sourceName',
                label: 'Denumire sursă finanțare',
                errReason: 'Introduceți denumirea sursa de finanțare.',
              }
            ],
            closeBtnText: 'Anulează',
            initialInputsData: item,
            button: {
              type: 2,
              value: 'Modifică',
              handler: sendData => {
                sendData = this.getEdited(sendData, item, true)
                
                const error = msg => {
                  this.$toastr.e(msg || 'Modificarea sursei de finanțare a eșuat.')
                  this.reloadPage()
                  this.setLoad()
                }

                this.setSafeLoad(12000)
                FINANCING_SOURCE.edit(item.id, sendData)
                  .then(res => {
                    if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                      this.$toastr.s('Sursa de finanțare a fost modificată.')
                      this.reloadPage()
                      this.setLoad()
                    } else {
                      error()
                    }
                  })
                  .catch(error)
              },
            },
          },
          {
            name: 'EditFinancing',
            adaptive: true,
            width: '650',
            height: '800',
          }
        )
      },
      prepareData(row) {
        const spacer = window.innerWidth > 900
        
        const preparation = [row.sourceName || '-']

        if(spacer) {
          preparation.push({spacer:true})
        }

        const x = this.PERMISIONS
        const prepareBtn = []

        const uuid = row.createdByUser
        const checkOwner = o => {
          if(!o) return false
          if(o === true) return true
          if(o == uuid) {
            return true
          }
          if(Array.isArray(o) && o[1] == uuid) {
            return true
          }
          return false
        }

        if(checkOwner(x.edit)) {
          prepareBtn.push(2)
        }
        if(checkOwner(x.delete)) {
          prepareBtn.push(3)
        }
        
        if(prepareBtn.length) {
          preparation.push([prepareBtn])
        }
        
        return preparation
      },
    },
    async created() {
      if(!this.PERMISIONS.list) {
        return
      }
      if(window.innerWidth > 900) {
        this.tableHead.push({spacer:true})
      }
      if(this.checkParamsInObj(this.PERMISIONS, ['edit', 'delete'])) {
        this.tableHead.push({spacer:true,minimize:1,fixed:{
          right: true
        },bottomHead: {
            quikFiltre: 'clear'
        }})
      }
    }
  }
</script>